"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WrapperCenter = void 0;
var styled_1 = __importDefault(require("@emotion/styled"));
exports.WrapperCenter = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: 100%;\n  width: 100%;\n  display: grid;\n  place-items: center;\n"], ["\n  height: 100%;\n  width: 100%;\n  display: grid;\n  place-items: center;\n"])));
var templateObject_1;
